import React, { useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Col,
  Row,
  notification,
  DatePicker,
} from "antd";
import "dayjs/locale/es-mx";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import SelectCities from "../../Elements/Select-Cities";
import SelectKnowledgeArea from "../../Elements/Select-Knowledge-Area";
import SelectKnowledgeSpecialty from "../../Elements/Select-Knowledge-Specialty";
import SelectKnowledgeGran from "../../Elements/Select-Knowledge-Gran";
import { update } from "../../../../../controllers/store/actions/projects/update-projects-actions";
import SelectProducts from "../../Elements/Select-Product-";
import SelectProjectStatus from "../../Elements/Select-Project-status";
import { Capacity } from "../../../..";

interface Props {
  loading?: boolean;
  project: any;
  visible: boolean;
  onUpdated: () => void;
  onCancel: () => void;
}

const dispatch = store.dispatch;
const UpdateProjectModal: React.FC<Props> = (props: Props) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const updatedProject = useSelector((state: any) => state.updatedProject);
  const CapacitiesTypeState = useSelector(
    (state: any) => state.capacitiesTypes
  );

  useEffect(() => {
    if (props.project) {
      form.setFieldsValue({
        ...props.project,
        city: { value: parseFloat(props.project.city) },
        area_de_conocimiento: { value: props.project.area_de_conocimiento.id },
        especialidad_de_conocimiento: {
          value: props.project.especialidad_de_conocimiento.id,
        },
        gran_area_de_conocimiento: {
          value: props.project.gran_area_de_conocimiento.id,
        },
        products: props.project.products.map((p: any) => ({
          value: p.products_id,
        })),
        estado_proyecto: { value: props.project.estado_proyecto.id },
      });
    }
  }, [form, props.project]);

  return (
    <Modal
      width={800}
      visible={props.visible}
      title={"Proyecto"}
      okText={"Actualizar"}
      cancelText="Cancelar"
      footer={null}
      onCancel={props.onCancel}
    >
      <>
        {contextHolder}
        <Form
          form={form}
          layout="vertical"
          onFinish={async (formValues: any) => {
            form.validateFields().then(async (values: any) => {
              await dispatch(
                update(props.project.id, {
                  ...values,
                  area_de_conocimiento: values.area_de_conocimiento?.value,
                  especialidad_de_conocimiento:
                    values.especialidad_de_conocimiento?.value,
                  gran_area_de_conocimiento:
                    values.gran_area_de_conocimiento?.value,
                  estado_proyecto: values.estado_proyecto?.value,
                  products: values.products?.map((p: any) => ({
                    products_id: p.value,
                  })),
                  city: values.city?.value,
                  capacity_type: CapacitiesTypeState.list.find(
                    (c: any) => c.collection_name === Capacity.Projects
                  )?.id,
                })
              );

              props.onUpdated();
            });
          }}
          name="updateProject"
        >
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col span={16}>
              <Form.Item
                label="Nombre del proyecto"
                name="titulo_proyecto"
                rules={[
                  { required: true, message: "Por favor ingrese el nombre" },
                ]}
              >
                <Input placeholder="Nombre del proyecto" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={8}>
              <Form.Item
                label="Ciudad"
                name="city"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectCities
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(value) => form.setFieldsValue({ city: value })}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Area general"
                name="area_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeArea
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(value) =>
                    form.setFieldsValue({ area_de_conocimiento: value })
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Área específica"
                name="especialidad_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeSpecialty
                  onClear={() => {}}
                  size="large"
                  onChange={(value) =>
                    form.setFieldsValue({ especialidad_de_conocimiento: value })
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Gran área del conocimiento"
                name="gran_area_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeGran
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(value) =>
                    form.setFieldsValue({ gran_area_de_conocimiento: value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Descripción detallada"
                name="descripcion_detallada"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese la descripción detallada",
                  },
                ]}
              >
                <Input.TextArea placeholder="Descripción detallada" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Tiempo de ejecución"
                name="tiempo_de_ejecucion_estimado"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el Tiempo estimado",
                  },
                ]}
              >
                <Input placeholder="Tiempo de ejecución" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Presupuesto"
                name="presupuesto_estimado"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el presupuesto",
                  },
                ]}
              >
                <Input placeholder="Presupuesto" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Tipo de proyecto"
                name="tipo_proyecto"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el tipo de proyecto",
                  },
                ]}
              >
                <Input placeholder="Tipo de proyecto" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Aliados del proyecto"
                name="aliados_del_proyecto"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese los aliados del proyecto",
                  },
                ]}
              >
                <Input placeholder="Aliados del proyecto" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={8}>
              <Form.Item
                label="Estado actual del proyecto"
                name="estado_proyecto"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectProjectStatus
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(value) =>
                    form.setFieldsValue({ estado_proyecto: value })
                  }
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Productos"
                name="products"
                rules={[{ type: "array" }]}
              >
                <SelectProducts
                  mode="multiple"
                  size="large"
                  onChange={(value) => {
                    form.setFieldsValue({ products: value });
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
          </Row>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <Button onClick={props.onCancel} style={{ marginRight: 8 }}>
              Cancelar
            </Button>
            <Button
              loading={updatedProject?.isLoading}
              type="primary"
              htmlType="submit"
            >
              Actualizar
            </Button>
          </div>
        </Form>
      </>
    </Modal>
  );
};

export default UpdateProjectModal;
